module.exports = __webpack_public_path__ + "static/media/user-tree-red.95bfdc07.svg";